import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { postSchedule, deleteSchedule } from "services/ConfigServices";
import useSchedulesTable from "./useSchedulesTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { scheduletext } from "variables/MBM/schedule";
import { typeData } from "variables/MBM/lists/schedule";
import { dico } from "variables/lists/dico";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ScheduleDialog from "./ScheduleDialog";
import FileCopyIcon from '@mui/icons-material/FileCopy';

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTSchedules = (props) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { wpgroup} = props;
  const [open, setOpen] = useState(false);
  const [currentSchedule, setCurrentSchedule] = useState(null);
  const { gridState, refetch, setSelectedSchedules, setLoading } = useSchedulesTable(wpgroup);


  const classes = useStyles();

  const columns = [
    {
      name: scheduletext.name,
      selector: (row) => row.parameters?.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.name,
    },
    {
      name: scheduletext.type,
      selector: (row) => row.parameters?.type,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => typeData.find((x) => x.id == row.parameters?.type)?.name || ""
    },
    {
      name: scheduletext.author,
      selector: (row) => row.parameters?.authorname,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.authorname,
    },
    {
      name: scheduletext.modifier,
      selector: (row) => row.parameters?.modifiername,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.modifiername,
    },
    {
      name: scheduletext.lastupdate,
      selector: (row) => row.parameters?.lastupdate,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.parameters?.lastupdate && moment(row.parameters?.lastupdate).isValid()
          ? moment(row.parameters?.lastupdate).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: scheduletext.group,
      selector: (row) => row.groupid,
      sortable: true,
      //  maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_geb_control_schedules ? (
              <>
                <Tooltip title="Editer le planning">
                  <Button
                    onClick={editSchedule(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Dupliquer le planning">
                  <Button
                    onClick={duplicateSchedule(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <FileCopyIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer le planning">
                  <CustomDeleteButton
                    deleteTitle={"Suppression du planning"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le planning ${row.parameters?.name}?`}
                    handleSupprimer={deleteSchedulesFunction(row)}
                  />
                </Tooltip>
              </>
            ) :
              <>
                <Tooltip title="Voir le planning">
                  <Button
                    onClick={editSchedule(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <VisibilityIcon fontSize="large" />
                  </Button>
                </Tooltip>
              </>
            }
          </div>
        </>
      ),
    },
  ];


  const ExpandableComponent = props => {
    const { data } = props;
    return (
      <Container>

      </Container>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editSchedule = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    if (obj) {
      setCurrentSchedule(obj);
      handleClickOpen();
    }
  }

  const duplicateSchedule = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    if (obj) {
      let newschedule = {...obj};
      newschedule.groups = ""+newschedule.groupid;
      delete newschedule.groupid;
      delete newschedule.id;
      newschedule.parameters.name = "(Copie) "+newschedule.parameters.name;     
      axios
        .post(
          postSchedule(),
          newschedule
          ,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            NotificationManager.success("Planning créé");
            refetch();
          } else NotificationManager.error("Une erreur est survenue");
        })
        .catch((error) => {
          NotificationManager.error("Une erreur est survenue");
          setLoading(false);
        });
    }
  }

  const deleteSchedulesFunction = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteSchedule(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le planning a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedSchedules(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun planning à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        // expandOnRowClicked={true}
        // expandableRows={true}
        // expandableRowDisabled={(row) => row.disabled}
        // expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'un planning
        </CustomDialogTitle>
        <DialogContent dividers>
          <ScheduleDialog
            closeModal={handleEditClose}
            setLoading={setLoading}
            setNotification={setNotification}
            refetch={refetch}
            currentSchedule={currentSchedule}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTSchedules;
